// extracted by mini-css-extract-plugin
export default {"wrapper":"link-list-module--wrapper--fecb1","link":"link-list-module--link--06266"};